<template>
  <div class="buy-qrcode">
    <div class="qrcode-header">
      <div class="qrcode-title">扫码支付</div>
      <div class="qrcode-pay-count">
        支付金额：
        <span style="font-size: 32px; font-weight: bold; color: #193032"
          >{{ price }}元</span
        >
      </div>
    </div>
    <div class="qrcode-main">
      <div class="qrcode-image-wrapper">
        <img class="qrcode-image" v-show="qrcode" :src="qrcode" alt="" />
        <div
          class="qrcode-disable"
          v-show="isTimeout"
          @click.stop="onRefreshQrcode"
        >
          刷新二维码
        </div>
      </div>
      <div class="qrcode-options">
        <div
          class="qrcode-btn-wxpay"
          :class="{ active: form.pay_type == 2 }"
          @click="form.pay_type = 2"
        >
          <div class="qrcode-icon"></div>
          <div class="qrcode-name">微信支付</div>
        </div>
        <div
          class="qrcode-btn-alipay"
          :class="{ active: form.pay_type == 1 }"
          @click="form.pay_type = 1"
        >
          <div class="qrcode-icon"></div>
          <div class="qrcode-name">支付宝</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiGetActivationCode,
  apiSearchMachine,
  apiPayCode,
  apiPayPoll,
} from '@/utils/api/index.js'

export default {
  data: () => ({
    form: {
      pay_type: 1,
      email: '',
      machine_id: '',
    },
    qrcode: null,
    order_no: null,
    price: 0,
    loopQuery: null,
    loopInterval: 2000,
    currentLoopTime: 0,
    maxLoopTime: 180000,
  }),
  watch: {
    'form.pay_type'(nv, ov) {
      this.getQrCode()
    },
  },
  computed: {
    isTimeout() {
      return this.currentLoopTime > this.maxLoopTime
    },
  },
  methods: {
    async getQrCode() {
      const { data: response } = await apiPayCode({ ...this.form })
      if (response.success) {
        const data = response.data
        this.qrcode = `data:image;base64,${
          data.wx_pay_code || data.ali_pay_code
        }`
        this.price = data.price * 0.01
        this.order_no = data.order_no
        this.onLoopQuery()
      } else {
        this.$router.go(-1)
        alert(response.msg)
      }
    },
    onRefreshQrcode() {
      // window.location.reload()
      this.getQrCode()
    },
    onLoopQuery() {
      this.currentLoopTime = 0
      clearInterval(this.loopQuery)
      this.loopQuery = setInterval(async () => {
        if (this.isTimeout) return clearInterval(this.loopQuery)
        this.currentLoopTime += this.loopInterval
        console.log(`this.currentLoopTime: ${this.currentLoopTime}`)
        const {
          data: { data },
        } = await apiPayPoll({
          pay_type: this.form.pay_type,
          order_no: this.order_no,
        })
        if (data) {
          clearInterval(this.loopQuery)
          this.getActivationCode()
        }
      }, this.loopInterval)
    },

    async getActivationCode() {
      const {
        data: { data },
      } = await apiGetActivationCode({
        machine_id: this.form.machine_id,
      })

      this.$router.replace({
        path: '/purchase/activationCode',
        query: { code: data.activation_code },
      })
    },
  },
  mounted() {
    // DF4136BB-59CC-7F30-DF22-7C2FC451A1B1
    this.form = { ...this.form, ...this.$route.query }
    this.getQrCode()
  },
  beforeDestroy() {
    clearInterval(this.loopQuery)
  },
}
</script>

<style lang="scss" scoped>
.buy-qrcode {
  display: flex;
  flex-direction: column;
  .qrcode-header {
    display: flex;
    width: 100%;
    font-size: 18px;
    color: #193032;
    margin-bottom: 48px;
    .qrcode-title {
      flex: 1;
      font-weight: bold;
    }
    .qrcode-pay-count {
    }
  }
  .qrcode-main {
    display: flex;
    .qrcode-image-wrapper {
      position: relative;
      width: 158px;
      height: 158px;
      background: #eeeeee;
      border: 2px solid #193032;
      border-radius: 8px;
      overflow: hidden;
      .qrcode-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      .qrcode-disable {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba($color: #000000, $alpha: 0.8);
        border-radius: 8px;

        font-size: 14px;
        color: white;
        z-index: 1;
        &:hover {
          color: #11dcc9;
        }
      }
    }
    .qrcode-options {
      align-self: flex-end;
      margin-left: 44px;
      .qrcode-btn-wxpay,
      .qrcode-btn-alipay {
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 14px;
        width: 164px;
        height: 52px;
        background: #ffffff;
        border: 2px solid #193032;
        border-radius: 8px;
        transition: cubic-bezier(0.075, 0.82, 0.165, 1);
        cursor: pointer;

        &.active {
          &::after {
            content: '';
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 40px;
            height: 40px;
            background-image: url('../../../assets/image/icon-select.png');
          }
          .qrcode-name {
            color: white;
          }
        }
        .qrcode-icon {
          width: 32px;
          height: 32px;
          background-position: center;
          background-repeat: no-repeat;
        }
        .qrcode-name {
          margin-left: 14px;
          font-size: 16px;
          color: #193032;
        }
      }
      .qrcode-btn-wxpay {
        &:hover {
          border: 2px solid #028b01;
        }
        .qrcode-icon {
          background-image: url('../../../assets/image/icon-wxpay.png');
        }
        &.active {
          background: #09bb07;
          border: 2px solid #028b01;
          .qrcode-icon {
            background-image: url('../../../assets/image/icon-wxpay-white.png');
          }
        }
      }
      .qrcode-btn-alipay {
        &:hover {
          border: 2px solid #2197f9;
        }
        margin-top: 22px;
        .qrcode-icon {
          background-image: url('../../../assets/image/icon-alipay.png');
        }
        &.active {
          background: #3da7fe;
          border: 2px solid #2197f9;
          .qrcode-icon {
            background-image: url('../../../assets/image/icon-alipay-white.png');
          }
        }
      }
    }
  }
}
</style>